// src/ApiService.js - Client-side API calls to Express server
const API_BASE_URL = '/api';

/**
 * Process multiple PDF pages via server
 */
export const processMultiplePages = async (pageImages, customPrompt) => {
  try {
    const response = await fetch(`${API_BASE_URL}/process-pages`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        pageImages: pageImages,
        prompt: customPrompt
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Server error: ${response.status}`);
    }

    trackMixPanelEvent('Instaform Result Generated', {
      result: 'success',
      error: null
    });
    const data = await response.json();
    return data.fields;
    
  } catch (error) {
    console.error('Error processing multiple pages:', error);
    trackMixPanelEvent('Instaform Result Generated', {
      result: 'failure',
      error: error.message
    });
    throw error;
  }
};

/**
 * Process a single image via server
 */
export const processImageWithGemini = async (imageData, prompt) => {
  try {
    const response = await fetch(`${API_BASE_URL}/process-image`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        imageData: imageData,
        prompt: prompt
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Server error: ${response.status}`);
    }

    trackMixPanelEvent('Instaform Result Generated', {
      result: 'success',
      error: null
    });

    const data = await response.json();
    return data.fields;
    
  } catch (error) {
    console.error('Error processing image:', error);
    trackMixPanelEvent('Instaform Result Generated', {
      result: 'failure',
      error: error.message
    });
    throw error;
  }
};

/**
 * Health check to verify server is running
 */
export const healthCheck = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/health`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Health check failed:', error);
    throw error;
  }
};

export const trackMixPanelEvent = async (name, properties = {}) => {
  const envInfo = getClientEnvInfo();

  try {
    let response = await fetch(`${API_BASE_URL}/trackMixPanelEvent`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name,
        properties: { 
          ...properties, 
          ...envInfo,
        }
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Server error: ${response.status}`);
    }

    return;
  } catch (error) {
    console.error('Mix Panel Tracking Failed', error);
  }
};

function getOrCreateUserId() {
  let id = localStorage.getItem('user_id');
  if (!id) {
    id = `user-${Math.random().toString(36).substring(2, 10)}`;
    localStorage.setItem('user_id', id);
  }
  return id;
}


function getClientEnvInfo() {
  const distinct_id = getOrCreateUserId(); // will auto-generate if not yet set

  return {
    distinct_id,
    userAgent: navigator.userAgent,
    language: navigator.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    screen: `${window.innerWidth}x${window.innerHeight}`,
    platform: navigator.platform,
  };
}